/**
 * Temporary flow traces for Hotel Flow Simplification refactor.
 * Keep alongside existing HOTEL_ENGINE_* traces until flow is stable.
 */

export const HOTEL_FLOW_TRACE = Object.freeze({
  STEP: "[HOTEL_FLOW_STEP_TRACE]",
  PERF: "[HOTEL_FLOW_PERF_TRACE]",
  CONTEXT: "[HOTEL_FLOW_CONTEXT_TRACE]",
});

/** Canonical step ids — align with end-to-end hotel flow audit. */
export const HOTEL_FLOW_STEP = Object.freeze({
  SEARCH_FORM: "1_search_form",
  PAYLOAD_BUILD: "2_payload_build",
  SUPPLIER_REQUEST: "3_supplier_request",
  RESPONSE_NORMALIZE: "4_response_normalize",
  CARDS_RENDER: "5_cards_render",
  FILTERS_SORT: "6_filters_sort",
  HOTEL_PROFILE: "7_hotel_profile",
  ROOM_SELECTION: "8_room_selection",
  BOOKING_PAYLOAD: "9_booking_payload",
  PAYMENT_RESERVE: "10_payment_reserve",
  SUCCESS_PAGE: "11_success_page",
});

const DEV =
  (typeof import.meta !== "undefined" && import.meta.env?.DEV) ||
  (typeof process !== "undefined" && process.env?.NODE_ENV === "development");

function emit(tag, payload) {
  if (!DEV) return;
  try {
    // eslint-disable-next-line no-console
    console.info(tag, payload);
  } catch {
    /* ignore */
  }
}

export function traceHotelFlowStep(step, payload = {}) {
  emit(HOTEL_FLOW_TRACE.STEP, {
    step,
    at: Date.now(),
    ...payload,
  });
}

export function traceHotelFlowPerf(label, durationMs, payload = {}) {
  emit(HOTEL_FLOW_TRACE.PERF, {
    label,
    durationMs: Math.round(durationMs * 100) / 100,
    at: Date.now(),
    ...payload,
  });
}

export function traceHotelFlowContext(stage, payload = {}) {
  emit(HOTEL_FLOW_TRACE.CONTEXT, {
    stage,
    at: Date.now(),
    ...payload,
  });
}

/** Start/end perf helper for pipeline boundaries. */
export function createHotelFlowPerfMark(label, payload = {}) {
  const start =
    typeof performance !== "undefined" && typeof performance.now === "function"
      ? performance.now()
      : Date.now();
  return {
    label,
    end(extra = {}) {
      const end =
        typeof performance !== "undefined" && typeof performance.now === "function"
          ? performance.now()
          : Date.now();
      traceHotelFlowPerf(label, end - start, { ...payload, ...extra });
      return end - start;
    },
  };
}
